import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var HowToFindBrandsThatHaveInsiderFreeShippingIA = function HowToFindBrandsThatHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING = function HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "PYlSze",
    defaultMessage: [{
      "type": 0,
      "value": "Merken met Gratis verzending met Insider vinden"
    }]
  }) : strictLocalize({
    id: "B8cwFF",
    defaultMessage: [{
      "type": 0,
      "value": "Hoe vind ik merken die gratis verzending met Insider hebben?"
    }]
  });
};
var TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING = function TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HHlKBq",
    defaultMessage: [{
      "type": 0,
      "value": "Om merken en producten te vinden die gratis verzending met Insider aanbieden, hoef je alleen maar naar het blauwe sleutelsymbool ‘Gratis verzending met Insider’ te zoeken tijdens het rondkijken op de website. Wanneer je een product of merk ziet met dit symbool, krijg je automatisch gratis verzending met Insider wanneer je bij dat merk afrekent. Bovendien kun je je winkelervaring aanpassen om alleen producten te tonen die gratis verzending met Insider hebben. Als je dit wilt doen, zoek je het Insider-filter bovenaan de categorie die je bekijkt en klik je erop."
    }]
  });
};